import { gql } from '@apollo/client';

export const uploadFileMutation = gql`
  mutation uploadFile($input: AdminUploadFileInput!) {
    uploadFile: adminUploadFile(input: $input)
  }
`;
